import { useEffect, useState } from "react";
import DatePicker from "tailwind-datepicker-react";
import { MdArrowBack, MdArrowForward, MdDateRange } from "react-icons/md"; // Import React Icons
import i18n from "../../i18n";
import './TimePicker.scss'
const MyDatePicker = ({ holder, resetDate,name, onChange, width }) => {
  const [show, setShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const isArabic = i18n.language === "ar";
  const arabicDays = ["ن","ث", "ع", "خ", "ج", "س", "ح"];
  
  const englishDays = ["Mon", "Tue", "Wed", "Thu", "Fri","Sat","Sun"];


  const options = {
    title: holder,
    autoHide: true,
    todayBtn: true,
    clearBtn: true,
  
    todayBtnText: isArabic ? "اليوم" : "Today",
    clearBtnText: isArabic ? "مسح" : "Clear",
  
    maxDate: new Date("2050-01-01"),
    minDate: new Date("1950-01-01"),
    defaultDate: new Date(),
  
    language: isArabic ? "ar" : "en",
    weekDays: isArabic ? arabicDays : englishDays,
    disabledDates: [],
  
    inputDateFormatProp: {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  
    /* ================= THEME ================= */
    theme: {
      /* Header */
      background:
        "datepicker-header bg-gradient-to-r from-primeColor-500 to-primeColor-400 text-white rounded-t-xl",
  
      icons: "text-secondColor",
  text: "text-primeColor-500 font-semibold",
      /* Today Button */
      todayBtn:
        "bg-primeColor-500 text-white font-semibold rounded-lg hover:bg-primeColor-400 transition",
  
      /* Clear Button */
      clearBtn:
        "bg-red-100 text-red-600 font-semibold rounded-lg hover:bg-red-200 transition",
  
      /* Disabled dates */
      disabledText:
        "text-gray-300 line-through cursor-not-allowed",
  
      /* Selected date */
      selected:
        "bg-secondColor text-black font-bold rounded-full shadow-md hover:bg-secondColor/90",
  
      /* Hover date */
      hover:
        "hover:bg-primeColor-100 hover:text-primeColor-500 rounded-full transition",
  
      /* Input hidden (you already use custom UI) */
      input: "hidden",
      inputIcon: "hidden",
    },
  
    /* ================= ICONS ================= */
    icons: {
      prev: () => (
        <MdArrowForward className="text-xl text-primeColor-500 hover:text-secondColor transition" />
      ),
      next: () => (
        <MdArrowBack className="text-xl text-primeColor-500 hover:text-secondColor transition" />
      ),
    },
  
    /* ================= POSITION ================= */
    datepickerClassNames:
      "top-14  max-w-sm rounded-xl shadow-xl border border-gray-100",
  
  };
   

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) {
      onChange(date); // Call parent onChange if passed
    }
  };

  useEffect(() => {
    if (resetDate) {
      setSelectedDate(null); // Clear the selected date
    }
  }, [resetDate]);

  const handleClose = (state) => {
    setShow(state);
  };

  return (
    <div className={`col-span-3  relative  w-[100%] ${width?`md:w-[${width}%]` : ''}`}>
      {/* Label for the input */}
      {holder && <label className="block mb-1 text-lg font-semibold text-gray-700">{holder}</label>}

      {/* Input field to display the selected date */}
      <input
        type="text"
        name={name}
        readOnly
        value={selectedDate ? selectedDate.toLocaleDateString("en-GB", options.inputDateFormatProp) : ""}
        placeholder={holder}
        className="w-full p-3  rounded-lg border border-gray-300 focus:border-primeColor-500 focus:ring-2 focus:ring-primeColor-500 focus:outline-none transition-all duration-300 shadow-md cursor-pointer"
        onClick={() => setShow(true)} // Open date picker on input click
      />
      
      {/* DatePicker component */}
      <DatePicker
        options={options}
        onChange={handleDateChange}
        show={show}
        setShow={handleClose}
      />
    </div>
  );
};

export default MyDatePicker;
